module.exports = __webpack_public_path__ + "static/media/DiscGuard Politiques de Confidentialités.19ca0f1a.pdf";